import { type LDClient, type LDContext } from 'launchdarkly-js-client-sdk'

let ldClient: LDClient | null = null
let applicationName: string

type ApplicationName = 'legacy-platform-ui' | 'expert-interface-ui'

export const getLDClient = () => ldClient
export const setLDClient = (client: LDClient) => {
  ldClient = client
}

export const setApplicationName = (appName: ApplicationName) => {
  applicationName = appName
}
export const getApplicationName = () => applicationName


export function getLDContext(): LDContext {
  if (!applicationName) {
    throw new Error('Application name not set!')
  }

  const launchDarklyContext: LDContext = {
    kind: 'multi',
    application: {
      key: applicationName
    }
  }
  try {
    const loggedInUser = window.localStorage.getItem('ngStorage-user')
    if (loggedInUser) {
      const parsed = JSON.parse(loggedInUser)
      const { id, fullName } = parsed || {}

      if (id && fullName) {
        launchDarklyContext.user = {
          key: id,
          name: fullName
        }
      }
    }
    return launchDarklyContext
  } catch (err) {
    return launchDarklyContext
  }
}

export async function refreshLDContext() {
  if (!ldClient) {
    return
  }

  const ldContext = getLDContext()

  await ldClient.identify(ldContext)
}